const dataPlanExtension = {
  dataPlanExtension: {
    heading: "Mobile Connect Data Extension",
    cellModemIMEI: "Cell Modem IMEI Number",
    siteName: "System Name",
    siteAddress: "System Address",
    cellPlanEndDate: "Cell Modem plan end date",
    daysToExpiry: "Days to expiry",
    currentPlanStatus: "Current plan status",
    gatewaySNo: "Gateway S.NO",
    paymentStatus: "Payment Status",
    lastDateOfPurchase: "Last Date Of Purchase",
    extendDataPlan: "Extend Data Plan",
    purchasedBy: "Purchased By",
    purchasedFrom: "Purchased From",
    siteId: "System ID",
    orderNo: "Order Number",
    footer: 'Mobile Connect Data Extension',
    total: 'Total',
    record: 'record',
    records: 'records',
    show: 'Show',
    enphase_store: 'Enphase Store',
    orderSummary: 'Order Summary.',
    confirmSelection: 'Please confirm your selection below',
    noOfCellModems: 'Number of Cell Modems',
    years: 'Years',
    pricePerSite: 'Price Per Site',
    cancel:'Cancel',
    submit:'Submit',
    back: 'Back',
    noTokens: '** No Cell Modems Available **',
    redirectToStoreText: 'Redirecting to Enphase Store! Please Wait...!',
    toolTipExtensionInfo: 'Only cell modem plans with less than 180 days to expiry are eligible for extension.',
    allCellModems: 'All Cell Modems',
    dataplanTitleTooltip: 'This is an extension to Enphase monitoring, software/firmware upgrades, and other remote services offered via your existing AT&T cell modem. This extension will enable you to continue using the same physical hardware, beyond its 5-year term you had originally purchased, by renewing its connectivity instead of having to purchase a new physical device.',
    eligibleCellModems: 'Eligible Cell Modems',
    nonAdminInfo: 'Please reach out to admin to extend the data plan for a cell modem',
    select: 'Select',
    typeToSearch: 'Type to Search',
    dataPlanExtensionSuccess: 'Mobile Connect Data Extension is successful. It might take some time for the payment to reflect in the dashboard',
    expired: 'Expired',
    active: 'Active',
    failed: "Payment Failed",
    pending: "Payment Processing",
    success: "Payment Successful",
  }
}

export default dataPlanExtension